import { render, staticRenderFns } from "./PublisherProductsCarousel.component.vue?vue&type=template&id=75b2de58&scoped=true"
import script from "./PublisherProductsCarousel.component.vue?vue&type=script&lang=js"
export * from "./PublisherProductsCarousel.component.vue?vue&type=script&lang=js"
import style0 from "./PublisherProductsCarousel.component.vue?vue&type=style&index=0&id=75b2de58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b2de58",
  null
  
)

export default component.exports